export const getTodayShortDate = () => new Date().toISOString().substring(0, 10)
